import {useEffect, useState} from 'react'
import WarningPatientEmptyData from 'src/components/elements/WarningEmptyCard/WarningPatientEmptyData'
import Filters, {FilterItem} from 'src/components/templates/Filters/Filters'
import SecondaryAssumptionsList from 'src/pages/secondaryAssumptions/SecondaryAssumptionsList'

type SecondaryAssumptionsDiaryPanelProps = {
  secondaryTherapies: Record<string, any>[]
  // Pre-selects "Terapia" when arriving already knowing which one matters — e.g. the "Vedi tutte
  // le assunzioni" link on the deep-link response page (SecondaryAssumptionResponse), which wants
  // to land here already scoped to that same therapy instead of making the patient re-pick it.
  initialTherapyId?: string
}

// Legacy-stack twin of pages-new/diary/SecondaryAssumptionsPanel.tsx — the reminders history for
// a single accessory therapy at a time, picked via the same "Filtra" convention as the rest of
// this page. Mounted in the "Terapie Accessorie" tab of Diario Paziente (TherapyDiary.tsx),
// moved here from the "Assunzioni" tab that used to live inside the therapy card on /therapies
// (see SecondaryTherapyCardTabs.tsx), aligning the legacy stack with the new one.
const SecondaryAssumptionsDiaryPanel: React.FC<SecondaryAssumptionsDiaryPanelProps> = ({secondaryTherapies, initialTherapyId}) => {
  const [selectedTherapyId, setSelectedTherapyId] = useState<string | undefined>(initialTherapyId ?? secondaryTherapies[0]?._id)

  useEffect(() => {
    if (!secondaryTherapies.some(therapy => therapy._id === selectedTherapyId)) {
      setSelectedTherapyId(secondaryTherapies[0]?._id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondaryTherapies])

  if (secondaryTherapies.length === 0) {
    return <WarningPatientEmptyData message='Nessuna terapia accessoria trovata' />
  }

  const filtersConfig: FilterItem[] = [
    {
      id: 'therapy',
      label: 'Terapia',
      type: 'select',
      defaultValue: selectedTherapyId as any,
      options: secondaryTherapies.map(therapy => ({label: therapy.drug?.name ?? 'Terapia accessoria', value: therapy._id}))
    }
  ]

  const handleFiltersSubmit = (results: {property: string; value: any}[]) => {
    const nextTherapy = results.find(r => r.property === 'therapy')?.value as string | undefined
    if (nextTherapy) { setSelectedTherapyId(nextTherapy) }
  }

  return (
    <div>
      <div style={{display: 'flex', justifyContent: 'flex-end', padding: '0 0 16px'}}>
        <Filters config={filtersConfig} onSubmit={handleFiltersSubmit} />
      </div>
      {selectedTherapyId && <SecondaryAssumptionsList secondaryTherapyId={selectedTherapyId} />}
    </div>
  )
}

export default SecondaryAssumptionsDiaryPanel
